import { Theme } from '../../models/system/theme';

/**
 * Theme "VogueTyre". Reference to setting in table dbo.Theme.
 */
export const Theme_VogueTyre: Theme = {
  name: 'VogueTyre', // Same as value of field "Code" in table dbo.Theme.
  properties: {
    /* own color */
    '--mainColor': '#0f141b', // Color 2
    '--mainButtomColor': '#0f141b', // main Buttom
    '--minorColor': '#ffc552', // Color 3
    '--mainColorB':'#000000',
    '--subColor': '#000000', // Color 1.
    '--mainBackgroundColor': '#213449', // Background
    '--mainTitleColor':'#f2f4f9',
    '--minorBackgroundColor': '#FFFFFF', // NAV
    '--importantLabel': '#333',
    '--ordinary_label': '#666',
    '--nonImportantLabel': '#999',
    '--dashColor1': '#abb5c4',
    '--dashColor2': '#777B84',
    '--controlColor_span1': '#1F2125',
    '--controlInptBackgroundColor1': '#f3f2f2',
    '--navTitleColor': '#FFFFFF',
    '--navTitleMinorColor': '#FFFFFF',

    '--extraPriceColor':'#287f3d',   
    '--inTransitColor':'#0435c5', 
    '--cartIconColor':'#FFFFFF',  
    '--grid_th_Color': '#F6F6F6',
    '--grid_td_Color': '#FFFFFF',


    /*hearder*/
    '--navbarBackground': '#0c1016',
    '--headerClickColor': '#000000',
    '--headerClickColor_border': '#090e2126',

    /*order*/
    '--controlColor_order_buttom1': '#000000',
    '--controlColor_order_buttom2': '#213449',
    '--controlColor_order_buttom3': '#000000',
    '--controlColor_order_buttom4': '#213449',
    '--controlColor_buttomBorder1': '#213449',

    /*cart*/
    '--grid_thColor': '#F6F6F6',
    '--controlColor_buttom2': '#090E22',
    '--controlColor_buttom3': '#000000',
    '--controlColor_buttom2_font': '#FFFFFF',
    '--dialogBackgroundColor': '#FFFFFF',

    '--noFillColor':'#62697b',
    '--disableCarat':"#ccc",

     /*Direct Container Order Grid */
     '--GridRightBorderTH': 'B3B2B3',
     '--GridRightBorderTD': '#CCC',
     '--GridHoverColorTR': '#ffc552',
     '--TextOnHover': '#213449'
     
    /* Bootstrap css override */
   }
};
